// extracted by mini-css-extract-plugin
export default {"agentsReviewsControls":"agentsReviewsControls_rLlgd","text":"text_K_qqN"};